/**
 * This file contains a way of parsing various file attributes
 *
 * @author Robert M Main
 * @copyright Learning Technologies, University of Aberdeen
 */

window.File = {
    /**
     * Convert a file size to a human readable format.
     * Shamelessly (and lazily) stolen from:
     * http://stackoverflow.com/questions/10420352/converting-file-size-in-bytes-to-human-readable
     *
     * @param int fileSizeInBytes
     * @returns String
     */
    getReadableFileSizeString: function (fileSizeInBytes, round) {
        return filesize(fileSizeInBytes * 1024, {
            spacer: '',
            standard: 'iec',
            round: round === undefined ? 2 : round,
        });
    },

    /**
     * Convert a file extension to a human readable format.
     *
     * @param int fileSizeInBytes
     * @returns String
     */
    getReadableExtension: function (extension) {
        var type;
        if (extension === 'docx' || extension === 'doc') {
            type = 'Word Document';
        } else if (extension === 'pptx' || extension === 'ppt') {
            type = 'PowerPoint';
        } else if (extension === 'pdf') {
            type = 'PDF Document';
        } else {
            type = 'Unknown File Format';
        }
        return type;
    },

    /**
     * Convert a file extension to a font awesome icon
     *
     * @param String fileSizeInBytes
     * @returns String
     */
    getIcon: function (extension) {
        var icon;
        if (extension === 'docx' || extension === 'doc') {
            icon = FontAwesome.prefix('regular', 'file-word');
        } else if (extension === 'pptx' || extension === 'ppt') {
            icon = FontAwesome.prefix('regular', 'file-powerpoint');
        } else if (extension === 'pdf') {
            icon = FontAwesome.prefix('regular', 'file-pdf');
        } else if (['jpg', 'png', 'gif'].includes(extension)) {
            icon = FontAwesome.prefix('regular', 'image');
        } else {
            icon = FontAwesome.prefix('regular', 'file');
        }
        return icon;
    },
};
